import { render, staticRenderFns } from "./StoreForm.vue?vue&type=template&id=23e0c3c5&"
import script from "./StoreForm.vue?vue&type=script&lang=ts&"
export * from "./StoreForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports